<template>
  <product
    :productService = productService
    :transactionService = transactionService
    :locationService = locationService
  ></product>
</template>

<script>
import Product from '@/components/Common/Rental/Products/Product'
import productService from '@/services/rental/product'
import transactionService from '@/services/rental/transaction'
import locationService from '@/services/rental/location'

export default {
  components: {
    Product
  },

  data () {
    return {
      productService: productService,
      transactionService: transactionService,
      locationService: locationService,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rental/Products/Product.vue